import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import { SearchTableHeader } from 'components/searchPlayerTable/SearchTableHeader';
import { StatsCell } from 'components/searchPlayerTable/SearchTableHeader/ui';

const StartStatsCell = styled(StatsCell)`
  justify-content: flex-start;
`;

export const CompletedTransactionsListHeader = () => {
  return (
    <SearchTableHeader
      firstCell={
        <LabelS>
          <FormattedMessage {...glossary.date} />
        </LabelS>
      }
    >
      <StartStatsCell>
        <LabelS>
          <FormattedMessage
            id="Player.CompletedTransactions.listHeader.type"
            defaultMessage="Type"
          />
        </LabelS>
      </StartStatsCell>
      <StatsCell>
        <LabelS>
          <FormattedMessage
            id="User.CompletedTransactions.received"
            defaultMessage="Received"
          />
        </LabelS>
      </StatsCell>
      <StatsCell>
        <LabelS>
          <FormattedMessage
            id="User.CompletedTransactions.listHeader.from"
            defaultMessage="From"
          />
        </LabelS>
      </StatsCell>
      <StatsCell>
        <LabelS>
          <FormattedMessage
            id="User.CompletedTransactions.sent"
            defaultMessage="Sent"
          />
        </LabelS>
      </StatsCell>
    </SearchTableHeader>
  );
};
